import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class TheatrePatientMaterials implements IDataStorage {
  Index: InternalIndex = new InternalIndex('TheatrePatientId', 'TheatrePatientId', false, false);
  PackIndex: InternalIndex = new InternalIndex('PackId', 'PackId', false, true);
  TheatrePatientIdIndex: InternalIndex = new InternalIndex('TheatrePatientId', 'TheatrePatientId', false, true);
  PackBasketIdIndex: InternalIndex = new InternalIndex('PackBasketId', 'PackBasketId', false, true);
  tableDefinition: InternalTable = new InternalTable('TheatrePatientMaterials', 'Id', true, [
    this.Index,
    this.PackIndex,
    this.TheatrePatientIdIndex,
    this.PackBasketIdIndex,
  ]);

  Id: number;
  TheatrePatientId: number;
  MaterialId: number;
  Quantity: number;
  OriginalQuantity: number;
  Name: string;
  UnitOfMeasure: string;
  Barcode: string;
  StockLocationId: number;
  PackId: number;
  PackBasketId: string;
  Username: string;

  static getTableDefinition(): InternalTable {
    return new TheatrePatientMaterials().tableDefinition;
  }
}
